(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDeleteController',VideoInformativoDeleteController);

    VideoInformativoDeleteController.$inject = ['$uibModalInstance', 'entity', 'VideoInformativo'];

    function VideoInformativoDeleteController($uibModalInstance, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VideoInformativo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
